import { RefObject, useEffect } from 'react';
import { HIGHLIGHT_CONTAINER_CLASS, HIGHLIGHT_CONTAINER_HOVERED_CLASS } from '../constants';

const mouseOverOutHandlerFactory = (container: HTMLElement, classAction: 'add' | 'remove') => (e: MouseEvent) => {
  const target = (e?.target as Element)?.closest(`.${HIGHLIGHT_CONTAINER_CLASS}`);

  if (target) {
    container.querySelectorAll(`.${HIGHLIGHT_CONTAINER_CLASS}`).forEach((element) => {
      element.classList[classAction](HIGHLIGHT_CONTAINER_HOVERED_CLASS);
    });
  }
};

export const useHighlightContainerHover = (articleContainer: RefObject<HTMLElement>) => {
  useEffect(() => {
    if (!articleContainer?.current) {
      return;
    }

    const onMouseOver = mouseOverOutHandlerFactory(articleContainer.current, 'add');
    const onMouseOut = mouseOverOutHandlerFactory(articleContainer.current, 'remove');

    articleContainer.current.addEventListener('mouseover', onMouseOver);
    articleContainer.current.addEventListener('mouseout', onMouseOut);
    return () => {
      articleContainer.current?.removeEventListener('mouseover', onMouseOver);
      articleContainer.current?.removeEventListener('mouseout', onMouseOut);
    };
  }, [articleContainer.current]);
};
